import { useState } from 'react';
import { useSecondModal } from "@helpers/hooks/useSecondModal";
import { useRecoilState } from 'recoil'
import { aboutUs } from '@atoms';
import './style.css'

const qaItems = [
	{
		question: "איך למחוק תמונה?",
		answer: "לוחצים על התמונה ואז על \"מחיקת תמונה\""
	},
	{
		question: "איך לערוך תמונה?",
		answer: "לוחצים על התמונה ואז על \"עריכה\" - שם אפשר להגדיל, להזיז ולהוסיף פילטרים"
	},
	{
		question: "איך להוסיף פילטר לתמונה?",
		answer: "לוחצים על התמונה, על \"עריכה\", ואז בוחרים פילטר מהאפשרויות למטה"
	},
	{
		question: "אפשר להסיר את התמונות ללא נזק לקיר?",
		answer: "בהחלט! המסגרות ניתנות להזזה והסרה בקלות ללא כל נזק לקיר. אפשר להזיז אותן ממקום למקום כמה שרוצים"
	},
	{
		question: "תוך כמה זמן ההזמנה מגיעה הביתה?",
		answer: "ההזמנה מגיעה בהתאם לזמנים המופיעים בעגלה בזמן הרכישה, וברוב המקרים נעשה את המיטב כדי שההזמנה תגיע אליכם בתוך 3-7 ימי עסקים"
	}
];

const WhatsAppMobile = () => {
	const modal = useSecondModal();
	const [, setAboutUs] = useRecoilState(aboutUs);
	const [openIndex, setOpenIndex] = useState(null);

	const toggleQA = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<div className="whatsapp_mobile">
			{/* Close button - X with gray circle */}
			<div
				className="whatsapp_close_btn"
				onClick={() => modal('close', 'whatsAppMobile')}
			>
				×
			</div>

			{/* Header */}
			<div className="whatsapp_mobile_header">
				היי :)
			</div>

			{/* Content */}
			<div className="whatsapp_mobile_content">
				אנחנו בבלנדס מעניקים שירות מהיר בוואצאפ בין השעות 09:30-20:30 מידי יום למעט ימי שישי, שבתות וחגים, לשיחה עם נציג פשוט הקליקו למטה ותועברו לשיחת וואצאפ עם אחד מנציגנו
			</div>

			{/* WhatsApp Link */}
			<div className="whatsapp_mobile_footer">
				<a
					className="whatsapp_mobile_link"
					href="https://wa.me/972504993895"
					target="_blank"
					rel="noreferrer"
				>
					תעבירו אותי לוואצאפ
					<img src="/assets/file/images/whatsapp_icon.svg" alt="WhatsApp"/>
				</a>
			</div>

			{/* Q&A Section */}
			<div className="whatsapp_qa_section">
				<div className="whatsapp_qa_title">שאלות נפוצות</div>

				{qaItems.map((item, index) => (
					<div
						key={index}
						className={`whatsapp_qa_item ${openIndex === index ? 'open' : ''}`}
					>
						<div
							className="whatsapp_qa_question"
							onClick={() => toggleQA(index)}
						>
							<span className="whatsapp_qa_icon">
								{openIndex === index ? '−' : '+'}
							</span>
							<span>{item.question}</span>
						</div>
						<div className="whatsapp_qa_answer">
							<div className="whatsapp_qa_answer_inner">
								{item.answer}
							</div>
						</div>
					</div>
				))}
			</div>

			{/* More Q&A Link */}
			<div className="whatsapp_more_qa">
				<span
					onClick={() => {
						setAboutUs('CQ')
						modal('close', 'whatsAppMobile');
						modal('open', 'aboutUsMobile')
					}}
				>
					לכל השאלות והתשובות
					<span className="whatsapp_more_arrow">←</span>
				</span>
			</div>
		</div>
	);
}

export default WhatsAppMobile;
